import {createContext, useContext} from "react";
import {DungeonSettings} from "@/encounter/model/DungeonSettings.ts";
import {Dungeon} from "@/dungeons/model/Dungeon.ts";

export type DungeonContextValue = {
    dungeon: Dungeon;
    dungeonSettings: DungeonSettings;
    previewDungeonSettings: (settings: DungeonSettings) => void;
    setDungeonSettings: (settings: DungeonSettings) => Promise<void>;
};

export const DungeonContext = createContext<DungeonContextValue | null>(null);

export function useDungeon(): DungeonContextValue {
    const context = useContext(DungeonContext);
    if (!context) throw new Error("useDungeon must be used within a DungeonProvider");
    return context;
}
